import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  filePopoverNameTitle: {
    id: 'ora-grading.FilePopoverContent.filePopoverNameTitle',
    defaultMessage: 'File Name',
    description: 'Popover title for file name',
  },
  filePopoverDescriptionTitle: {
    id: 'ora-grading.FilePopoverCellContent.filePopoverDescriptionTitle',
    defaultMessage: 'File Description',
    description: 'Popover title for file description',
  },
  fileSizeTitle: {
    id: 'ora-grading.FilePopoverCellContent.fileSizeTitle',
    defaultMessage: 'File Size',
    description: 'Popover title for file size',
  },
});

export default messages;
